import React, { useState } from "react"
import { baseDate, monthNames } from "../utils/settings"
import { dateToScrollPosition } from "../utils/datePositionUtils"
import CustomDate from "../utils/CustomDate"

export const TariheGit = ({ onScrollPositionChange, interval }) => {
	const [targetYear, setTargetYear] = useState(baseDate.getFullYear())
	const [targetMonth, setTargetMonth] = useState(0)
	const [targetDay, setTargetDay] = useState(1)
	const handleGoToDate = (e) => {
		e.preventDefault()

		let year = parseInt(targetYear)

		const month = parseInt(targetMonth) // 0-11 arası (0=Ocak)
		const day = parseInt(targetDay)

		// Validasyon - geçersiz değerler için uyarı
		if (isNaN(year)) {
			alert("Geçersiz yıl!")
			return
		}
		if (isNaN(month)) {
			alert("Geçersiz ay!")
			return
		}
		if (isNaN(day)) {
			alert("Geçersiz gün!")
			return
		}

		try {
			// CustomDate nesnesi oluştur

			const targetDate = new CustomDate(year, month, day)
			// console.log(interval)
			// Create a proper interval object if we receive just a string
			let intervalObj = interval;

			// console.log("Using interval object:", intervalObj);
			
			// Yeni fonksiyonumuzu kullanarak scroll pozisyonunu hesapla
			const scrollPos = dateToScrollPosition(
				targetDate,
				intervalObj,
				baseDate
			)

			console.log("Hesaplanan scroll pozisyonu:", scrollPos)

			// Hesaplanan scroll pozisyonunu kullan
			onScrollPositionChange(scrollPos)
			if (scrollPos===scrollPos)   // NaN kontrolü
			{
				localStorage.setItem('timelineScrollPosition', scrollPos)
				onScrollPositionChange(scrollPos)
			}


			
		} catch (error) {
			console.error("Tarih hesaplaması sırasında hata:", error)
			alert(
				"Tarih hesaplaması sırasında bir hata oluştu. Lütfen geçerli bir tarih girin."
			)
		}
	}

	return (
		<div>
			<form onSubmit={handleGoToDate} className="flex items-center gap-2 z-[9999]">
				<div className="relative">
					<input
						type="text"
						value={targetYear}
						onChange={(e) => {
							setTargetYear(e.target.value)
						}}
						placeholder="Yıl (Örn: 1000 BC)"
						className="w-44 h-8 px-2 text-center bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300 transition-colors rounded"
						title="Yıl değeri (MÖ için BC veya MÖ ekleyin, örneğin: 1000 BC)"
					/>
				</div>
				<select
					value={targetMonth}
					onChange={(e) => setTargetMonth(e.target.value)}
					className="h-8 bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300 transition-colors rounded"
					title="Ay seçimi"
				>
					{monthNames.map((ay, i) => (
						<option key={i} value={i}>
							{ay}
						</option>
					))}
				</select>
				<input
					type="number"
					value={targetDay}
					onChange={(e) => {
						// Ay ve yıla göre maksimum gün sayısını hesapla
						let year = parseInt(targetYear)


						const date = new CustomDate(
							year,
							parseInt(targetMonth),
							1
						)
						const maxDays = date.getDaysInMonth()

						setTargetDay(
							Math.max(
								1,
								Math.min(maxDays, Number(e.target.value))
							)
						)
					}}
					placeholder="Gün"
					min="1"
					max="31"
					className="w-14 h-8 px-2 rounded text-center bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300 transition-colors"
					title="Gün değeri (1-31)"
				/>
				<button
					type="submit"
					className="  h-8 px-3  bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors border border-gray-300 rounded"
					title="Seçilen tarihe git"
				>
					Git

				</button>
			</form>
		</div>
	)
}
